import { Link } from '@tanstack/react-router';

import { BrandLogo, cn } from '@keboola/design';

/**
 * ⚠️ Not the single source: route `head()` titles and `index.html` hardcode
 * `'… | Keboola Developer Portal'`.
 */
const APP_NAME = 'Developer Portal';

const SIZES = {
  /** The top bar of both chromes; sits on `Navbar`'s `bg-sidebar`. */
  bar: { gap: 'tw:gap-2.5', mark: 'tw:h-6', text: 'tw:text-sm tw:text-sidebar-foreground' },
  /** Above the signed-out card, the page's only chrome. */
  auth: { gap: 'tw:gap-3', mark: 'tw:h-10', text: 'tw:text-lg tw:text-foreground' },
} as const;

type Props = {
  size?: keyof typeof SIZES;
  className?: string;
};

/**
 * The brand's logomark plus this app's own name (not the brand's), linking home.
 *
 * - ⚠️ Mark is `aria-hidden`: `BrandLogo` labels itself, so the link would announce two names.
 * - `text-primary` sits on the mark's wrapper: logomarks fill with `currentColor`, the name must not.
 * - ⚠️ Keep each size's text colour: `AuthChrome` sets none, so an inheriting name renders UA black.
 * - `tracking-chrome` is brand-driven, so spacing re-skins with the brand.
 */
export function AppWordmark({ size = 'bar', className }: Props) {
  const { gap, mark, text } = SIZES[size];

  return (
    <Link to="/" className={cn('tw:flex tw:items-center tw:no-underline', gap, className)}>
      <span aria-hidden="true" className="tw:flex tw:items-center tw:text-primary">
        <BrandLogo variant="mark" className={mark} />
      </span>
      <span className={cn('tw:font-semibold tw:tracking-chrome', text)}>{APP_NAME}</span>
    </Link>
  );
}
